// import TextField from "@mui/material/TextField";
// import Stack from "@mui/material/Stack";
// import Autocomplete from "@mui/material/Autocomplete";
// import {useParams} from 'react-router-dom'
// export default function FreeSolo({
//   titles = [],
//   name ,
//   value,
//   error,
//   helperText,
//   setFieldValue,
//   label = "Title",
// }) {
//     const { projectId } = useParams();
//   const options = titles.map((t) => t[name]);

//   const uniqueEnteries = [...new Set(options)]

// const searchChnage = (e)=>{
//   console.log(e.target.value)
// }

//   return (
//     <Stack spacing={2}>
//       <Autocomplete
//         fullWidth
//         freeSolo
//         options={uniqueEnteries}
//         inputValue={value || ""} // ✅ show what's in Formik as input text
//         onInputChange={(event, newInputValue, reason) => {
//           // reason can be: 'input', 'reset', 'clear'
//           if (reason === "input" || reason === "clear") {
//             setFieldValue(name, newInputValue);
//             console.log(newInputValue)
//         }
//         }}
//         onChange={(event, newValue) => {
//           // ✅ when user picks from dropdown OR presses enter on typed text
//           setFieldValue(name, newValue || "");
//         }}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             name={name}
//             fullWidth
//             margin="normal"
//             label={label}
//             error={!!error}
//             helperText={helperText}
//             onChange={searchChnage}
//           />
//         )}
//       />
//     </Stack>
//   );
// }

// import React, { useState, useMemo, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useParams } from "react-router-dom";
// import TextField from "@mui/material/TextField";
// import Stack from "@mui/material/Stack";
// import Autocomplete from "@mui/material/Autocomplete";
// import { CircularProgress } from "@mui/material";

// import { fetchTransactions } from "../../store/transactionSlice"; // Import your fetchTransactions action

// export default function FreeSolo({
//   titles = [], // Titles coming from the parent component
//   name,
//   value,
//   error,
//   helperText,
//   setFieldValue,
//   label = "Title",
// }) {
//   const { projectId } = useParams();
//   const dispatch = useDispatch();
//   const [options, setOptions] = useState(titles?.map((item) => item[name])); // Initialize with the titles passed from the parent
//   const [loading, setLoading] = useState(false); // Loading state to show when fetching data
//   const [errorState, setErrorState] = useState(""); // Error handling state

//   // Memoize params to avoid unnecessary re-renders
//   const params = useMemo(() => {
//     return {
//       page: 1,
//       limit: 10, // Modify as per your limit
//       q: value || "", // Using the value entered in the search field
//     };
//   }, [value]);

//   const searchChange = async (e) => {
//     const query = e.target.value;

//     setFieldValue(name, query); // Update Formik field value

//     if (!query.trim()) {
//       setOptions(titles); // Reset to default titles when input is cleared
//       return;
//     }

//     setLoading(true); // Start loading

//     try {
//       // Dispatch action to fetch transactions
//       const result = await dispatch(fetchTransactions({ projectId, params }));
//       console.log(result);
//       // Assuming the backend response has a `items` field with the data you need
//       const formatedItrems = result?.payload?.items?.map((item) => item[name]);
//       const uniqueEnteries = [...new Set(formatedItrems)];
//       setOptions(uniqueEnteries);
//       setErrorState(""); // Clear any previous error
//     } catch (error) {
//       setErrorState("Failed to fetch transactions.");
//       console.error(error);
//     } finally {
//       setLoading(false); // Stop loading after fetch
//     }
//   };

//   useEffect(() => {
//     // Reset options when titles change (i.e., on initial load or if parent passes new titles)
//     setOptions(titles?.map((item) => item[name]));
//   }, [titles]); // Depend on titles prop

//   return (
//     <Stack spacing={2}>
//       <Autocomplete
//         fullWidth
//         freeSolo
//         options={options}
//         inputValue={value || ""}
//         onInputChange={(event, newInputValue, reason) => {
//           // reason can be: 'input', 'reset', 'clear'
//           if (reason === "input" || reason === "clear") {
//             setFieldValue(name, newInputValue); // Set Formik value
//           }
//         }}
//         onChange={(event, newValue) => {
//           setFieldValue(name, newValue || ""); // Set Formik value on selection
//         }}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             name={name}
//             fullWidth
//             margin="normal"
//             label={label}
//             error={!!errorState}
//             helperText={errorState || helperText}
//             onChange={searchChange} // Call the searchChange function on input change
//             InputProps={{
//               ...params.InputProps,
//               endAdornment: loading ? (
//                 <CircularProgress color="inherit" size={24} />
//               ) : null, // Show loader while fetching
//             }}
//           />
//         )}
//       />
//     </Stack>
//   );
// }

import React, { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress } from "@mui/material";
import {
  fetchTransactions,
  fetchTransactionsDropdown,
} from "../../store/transactionSlice"; // Import your fetchTransactions action

export default function FreeSolo({
  titles = [], // Titles coming from the parent component
  name,
  value,
  error,
  helperText,
  setFieldValue,
  label = "Title",
}) {
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const [options, setOptions] = useState(titles?.map((item) => item[name])); // Initialize with the titles passed from the parent
  const [loading, setLoading] = useState(false); // Loading state to show when fetching data
  const [errorState, setErrorState] = useState(""); // Error handling state

  // Memoize params to avoid unnecessary re-renders
  const params = useMemo(() => {
    return {
      page: 1,
      limit: 10, // Modify as per your limit
      q: value || "", // Using the value entered in the search field
    };
  }, [value]);

  // Handle search input change
  const searchChange = async (e) => {
    const query = e.target.value;

    setFieldValue(name, query); // Update Formik field value

    setLoading(true); // Start loading

    try {
      // Dispatch action to fetch transactions
      const result = await dispatch(
        fetchTransactionsDropdown({ projectId, params }),
      );
      // Assuming the backend response has a `items` field with the data you need
      const formattedItems = result?.payload?.items?.map((item) => item[name]);

      const uniqueEntries = [...new Set(formattedItems)];

      setOptions(uniqueEntries); // Update options with fetched data
      setErrorState(""); // Clear any previous error
    } catch (error) {
      setErrorState("Failed to fetch transactions.");
      console.error(error);
    } finally {
      setLoading(false); // Stop loading after fetch
    }
  };

  // Reset options when titles change (i.e., on initial load or if parent passes new titles)
  useEffect(() => {
    const unique = [...new Set(titles.map((item) => item[name]))];
    setOptions(unique);
  }, [titles, name]); // Depend on titles and name props

  return (
    <Stack spacing={2}>
      <Autocomplete
        fullWidth
        freeSolo
        options={options}
        inputValue={value || ""}
        onInputChange={(event, newInputValue, reason) => {
          // reason can be: 'input', 'reset', 'clear'
          if (reason === "input" || reason === "clear") {
            setFieldValue(name, newInputValue); // Set Formik value
          }
        }}
        onChange={(event, newValue) => {
          setFieldValue(name, newValue || ""); // Set Formik value on selection
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            fullWidth
            margin="normal"
            label={label}
            error={!!errorState}
            helperText={errorState || helperText}
            onChange={searchChange} // Call the searchChange function on input change
            InputProps={{
              ...params.InputProps,
              endAdornment: loading ? (
                <CircularProgress color="inherit" size={24} />
              ) : null, // Show loader while fetching
            }}
          />
        )}
      />
    </Stack>
  );
}
